export const DATA_INITIAL = 'houseAuditDetail/DATA_INITIAL';
export const ACCEPT = 'houseAuditDetail/ACCEPT';
export const UPDATE_AUDITINFO = 'houseAuditDetail/UPDATE_AUDITINFO';
export const UPDATE_HOUSESTATUS = 'houseAuditDetail/UPDATE_HOUSESTATUS';
export const UPDATE_ACCPETORNAME = 'houseAuditDetail/UPDATE_ACCPETORNAME';

const initialState = {
    // 当前用户信息
    userInfo: {
        userId: "qian_xie",
    },
    // 审核信息
    auditInfo: {
        isAccepting: false,  // 是否受理中
        acceptorID: "",
        acceptorName: "",
        acceptTime: "",
        houseStatus: "待审核",
    },
    // 基础房源详细
    baseHouseInfo: {
        property_card_address: "雄县 朱各庄镇 万科金色花园 十里堡西里119号楼15层1514QQ",
        plat_house_code: "XA12313674673QQ",
        community_name: "万科金色花园GOLD"
    },
    // 房源信息 - 产权信息
    propertyRightInfo: {
        attribution: "河北HB",
        letter: "冀J",
        record_num: "XA1231355XA",

        nature: "住宅ZZ",
        planning: "住宅ZZ",
        method_get: "2017-12-11",

        register_time: "2017-12-11",
        property_begin: "2017-12-11",
        property_end: "2017-12-11",

        years: "70年",
        land_number: "冀JJ",

    },
    // 房源信息 - 业主信息
    yezhuInfo: {
        name: "我是大业主",
        sex: "男",
        mobile: "13719544172",
        idCard: "441188199409283344"
    },
    // 房源信息 - 共有产权人信息
    commonPropertyOwnerInfo: [
        {
            name: "蟹钳",
            idCard: "441581199409282222",
            attachments: [
                { src: "http://img95.699pic.com/photo/40009/8361.jpg_wh860.jpg", alt: "身份证正面", title: "身份证正面" },
                { src: "http://img95.699pic.com/photo/40009/0939.jpg_wh860.jpg", alt: "身份证反面", title: "身份证反面" },
                { src: "http://img95.699pic.com/photo/40009/2273.jpg_wh860.jpg", alt: "共有人授权委托书", title: "共有人授权委托书" }
            ]
        },
        {
            name: "蟹钳",
            idCard: "441581199409282222",
            attachments: [
                { src: "http://img95.699pic.com/photo/40009/4502.jpg_wh860.jpg", alt: "身份证正面", title: "身份证正面" },
                { src: "http://img95.699pic.com/photo/40009/5974.jpg_wh860.jpg", alt: "身份证反面", title: "身份证反面" },
                { src: "http://img95.699pic.com/photo/40009/8361.jpg_wh860.jpg", alt: "共有人授权委托书", title: "共有人授权委托书" },
                { src: "http://img95.699pic.com/photo/40009/0939.jpg_wh860.jpg", alt: "共有人授权委托书", title: "共有人授权委托书" }
            ]
        }
    ],
    // 房源信息 - 房屋信息
    houseInfo: {
        frame_bedroom: 3,
        frame_parlour: 4,
        frame_toilet: 5,
        area: 120,
        actualArea: 100,

        floor: 16,
        total_floor: 55,
        orientations: "东南",

        decoration: "豪装G",
        heating_method: "集体供暖N",
        furniture_info: "wifi、电视机2、沙发、冰箱、空调、床、书桌、椅子、衣橱、热水器、洗衣机、餐桌、微波炉、燃气灶、油烟机",
    },
    // 房源信息 - 出租信息
    rentInfo: {
        price: 10000,
        rent_type: "押一付十",
        rent_max_period: "100",

        time_start: "2018-01-02",
        allow_sublease: "是",
        allow_anytime_showings: "否",
    },
    // 房源信息 - 房间图片
    housePicture: [
        { src: "http://img95.699pic.com/photo/40009/0939.jpg_wh860.jpg", alt: "新年快乐1" },
        { src: "http://img95.699pic.com/photo/40009/8361.jpg_wh860.jpg", alt: "新年快乐2" },
        { src: "http://img95.699pic.com/photo/40009/2273.jpg_wh860.jpg", alt: "新年快乐3" },
        { src: "http://img95.699pic.com/photo/40009/4502.jpg_wh860.jpg", alt: "新年快乐4" },
        { src: "http://img95.699pic.com/photo/40009/5974.jpg_wh860.jpg", alt: "新年快乐5" }
    ],
    // 房源轨迹
    houseTrack: [
        {
            key: 1,
            type: '交易取消1',
            result: '房源重新上架',
            remark: "备注",
            operationtime: '2018-02-01 21:00',
            operator: "陈先生"
        }, {
            key: 2,
            type: '交易取消2',
            result: '房源重新上架',
            remark: "备注",
            operationtime: '2018-02-01 21:00',
            operator: "陈先生"
        }, {
            key: 3,
            type: '交易取消3',
            result: '房源重新上架',
            remark: "备注",
            operationtime: '2018-02-01 21:00',
            operator: "陈先生"
        }, {
            key: 4,
            type: '交易取消4',
            result: '房源重新上架',
            remark: "备注",
            operationtime: '2018-02-01 21:00',
            operator: "陈先生"
        }, {
            key: 5,
            type: '交易取消5',
            result: '房源重新上架',
            remark: "备注",
            operationtime: '2018-02-01 21:00',
            operator: "陈先生"
        }
    ],
    // 预约记录
    reservationRecord: [
        {
            key: 1,
            username: '陈先生1',
            phone: '13719544172',
            appointmenttime: "2018-02-01 21:00",
            message: '留言',
            inputtime: "2018-02-01 21:00"
        }, {
            key: 2,
            username: '陈先生2',
            phone: '13719544172',
            appointmenttime: "2018-02-01 21:00",
            message: '留言',
            inputtime: "2018-02-01 21:00"
        }, {
            key: 3,
            username: '陈先生3',
            phone: '13719544172',
            appointmenttime: "2018-02-01 21:00",
            message: '留言',
            inputtime: "2018-02-01 21:00"
        }, {
            key: 4,
            username: '陈先生4',
            phone: '13719544172',
            appointmenttime: "2018-02-01 21:00",
            message: '留言',
            inputtime: "2018-02-01 21:00"
        }, {
            key: 5,
            username: '陈先生5',
            phone: '13719544172',
            appointmenttime: "2018-02-01 21:00",
            message: '留言',
            inputtime: "2018-02-01 21:00"
        }
    ]
};

// reducer
export default (state = initialState, action) => {
    switch (action.type) {
        // 数据初始化
        case DATA_INITIAL:
            return { ...state, ...action.payload };
        // 更新审核信息
        case UPDATE_AUDITINFO:
            return { ...state, auditInfo: { ...state.auditInfo, ...action.payload } };
        // 受理
        case ACCEPT:
            return { ...state, auditInfo: { ...state.auditInfo, ...action.payload } };
        // 更新房源状态
        case UPDATE_HOUSESTATUS:
            return { ...state, auditInfo: { ...state.auditInfo, ...action.payload } };
        default:
            return state
    }
}

// ActionCreator
export const dispatch_func = {
    // 数据初始化
    DataInitial: (data) => {
        return {
            type: DATA_INITIAL,
            payload: data
        };
    },
    // 更新审核信息
    UpdateAuditInfo: (data) => {
        return {
            type: UPDATE_AUDITINFO,
            payload: data
        }
    },
    // 受理
    Accept: (data) => {
        return {
            type: ACCEPT,
            payload: data
        }
    },
    // 更新房源状态
    UpdateHouseStatus: (data) => {
        return {
            type: UPDATE_HOUSESTATUS,
            payload: data
        }
    }
};


// WEBPACK FOOTER //
// ./src/modules/houseAuditDetail.js